var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row-box"},_vm._l((_vm.data),function(value,index){return _c('WrapperField',{key:value + index,attrs:{"data":_vm.createDataField({
        fieldName: index,
        fieldValue: value,
        fieldGroup: _vm.FieldGroup.STORAGE_ACCEPT_DETAILS,
      })}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }